import axios from 'axios'

// URL base dell'API per le soglie dei referendum, recuperato dall'env file

const SOGLIE_REFERENDUM_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'soglie-referendum'

const headers = { 'Content-Type': 'application/json' }

class SoglieReferendumService {
    /**
     * Salva o aggiorna le soglie del referendum nel sistema.
     * Effettua una richiesta POST a `/soglie-referendum/save` con i dati delle soglie dei referendum.
     *
     * @param {Object} iniziativa - Oggetto contenente i dettagli delle soglie dei referendum da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    aggiornaSoglieReferendum(referendum) {
        return axios.post(SOGLIE_REFERENDUM_REST_API_URL + "/save", referendum, headers);
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const soglieReferendumServiceInsance = new SoglieReferendumService()
export default soglieReferendumServiceInsance